/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React, { useEffect, useState, createRef, useReducer } from "react";
import PropTypes from "prop-types";
import { withLDConsumer } from "launchdarkly-react-client-sdk";

import utils from "@utils";
import { PaymentService, InvoiceService, JobService } from "@services";
import {
	NON_RKPAY_INVOICE_COLUMNS,
	NON_RK_PAY_INVOICE_STATUS_V4,
	NON_RKPAY_INVOICE_TYPE,
	NON_RKPAY_INVOICE_TYPE_OPTIONS,
	PAYMENTS_V4_TAB_MENU,
	SEND_INVOICE_METHODS,
} from "@constants";
import NonRKPayInvoiceEstimatesService from "@services/NonRKPayInvoiceEstimatesService";
import EstimatesTable from "./components/EstimatesTable";
import EstimatesTableV2 from "./components/EstimatesTableV2";
import PaidTable from "./components/PaidTable";
import PendingJobsTable from "./components/PendingJobsTable";
import PendingSubmissionTable from "./components/PendingSubmissionTable";
import AwaitingPaymentTable from "./components/AwaitingPaymentTable";

import {
	ApplyPaymentsModal,
	HeaderGrid,
	MultipleOfficerModal,
	SearchField,
	TabMenu,
} from "../../../components";

import "./NonRKPayInvoiceListV4.scss";
import NonRKPayInvoiceFilters from "./NonRKPayInvoiceFilters";
import AddToInvoiceModal from "../AddToInvoicie/AddToInvoiceModal";
import { FEATURES, PAYMENTS_TAB_MENU } from "../../../js/constants";
import SelectSendInvoicesMethodModal from "../PaymentSummary/modals/SelectSendInvoicesMethod/SelectSendInvoicesMethodModal";

// Cancellation Token
let invoicesCancel;
let estimatesCancel;

const NonRKPayInvoiceListV4 = ({
	user,
	flags: {
		bulkSendingInvoicesV4,
		clientV4InvoicingDisputes,
		onlyVoidedToggleEnabled,
		estimateTabAvailablefundsColumn,
		nonrkpayDetailPrepayEnhancements,
		useNonrkpayEstimatesQuery
	},
	router: {
		push,
		params: { viewType },
		location: { query },
		getCurrentLocation,
	},
}) => {
	const useNonrkpayEstimatesQueryEnabled = !!useNonrkpayEstimatesQuery;
	const { lang } = global;
	const [records, setRecords] = useState([]);
	const [estimateRecords, setEstimateRecords] = useState([]);
	const [filters, setFilters] = useState({});
	const [showFilters, setShowFilters] = useState(false);
	const [pageNumber, setPageNumber] = useState(1);
	const [hasMoreRecords, setHasMoreRecords] = useState(false);
	const [hasMoreEstimateRecords, setHasMoreEstimateRecords] = useState(false);
	const [selectedRecords, setSelectedRecords] = useState({});
	const [activeType, setActiveType] = useState(viewType);
	const [multipleSelection, setMultipleSelection] = useState(false);
	const [loadingCounts, setLoadingCounts] = useState(false);
	const [counts, setCounts] = useState({
		EstimatesTotalAmount: utils.currencyFormatter(0),
		JobsPendingInvoiceCreationCount: 0,
		PendingSubmissionToClientTotalAmount: utils.currencyFormatter(0),
		PendingClientPaymentTotalAmount: utils.currencyFormatter(0),
	});
	const [showAddToInvoice, setShowAddToInvoice] = useState(false);
	const [showMultipleOfficers, setShowMultipleOfficers] = useState(false);
	const [showSelectSendInvoicesMethodModal, setShowSelectSendInvoicesMethodModal] =
		useState(false);
	const [initialFiltersLoaded, setInitialFiltersLoaded] = useState(false);
	const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
	const applyPaymentsModalRef = createRef();
	const [, forceUpdate] = useReducer(x => x + 1, 0);
	const [updateTotals, setUpdateTotals] = useState(true);

	const excludeArchivedOptions = [
		NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key,
		NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key,
		NON_RKPAY_INVOICE_TYPE.AWAITING_PAYMENT.key,
	];

	const appendCoordinatorIdsParams = (urlSearchParams, queryFilters) => {
		if (
			queryFilters.supervisorIds &&
			Array.isArray(queryFilters.supervisorIds) &&
			queryFilters.supervisorIds.length > 1
		) {
			const idParam = "supervisorIds";

			if (urlSearchParams.has(idParam)) {
				urlSearchParams.delete(idParam);
			}

			queryFilters.supervisorIds.forEach(id => {
				urlSearchParams.append(idParam, id);
			});
		}
	};

	const getDefaultSortBy = type => {
		let defaultSortField;
		let defaultAsc;

		switch (type) {
			case NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key:
				defaultSortField = NON_RKPAY_INVOICE_COLUMNS.JobId;
				defaultAsc = true;
				break;
			case NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key:
				defaultSortField = NON_RKPAY_INVOICE_COLUMNS.IssueDate;
				defaultAsc = false;
				break;
			case NON_RKPAY_INVOICE_TYPE.AWAITING_PAYMENT.key:
				defaultSortField = NON_RKPAY_INVOICE_COLUMNS.SentDate;
				defaultAsc = false;
				break;
			case NON_RKPAY_INVOICE_TYPE.PAID.key:
				defaultSortField = NON_RKPAY_INVOICE_COLUMNS.DueDate;
				defaultAsc = false;
				break;
			case NON_RKPAY_INVOICE_TYPE.ESTIMATES.key:
			default:
				defaultSortField = NON_RKPAY_INVOICE_COLUMNS.IssueDate;
				defaultAsc = false;
				break;
		}

		return [defaultSortField, defaultAsc];
	};

	const onInvoiceNumberFilter = async invoiceNumber => {
		if (invoiceNumber === "") return;
		const currentRoute = window.location.href;

		try {
			if (activeType === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key) {
				await JobService.getById(invoiceNumber);
				push(`/jobs/${invoiceNumber}`);
			} else {
				// eslint-disable-next-line no-use-before-define
				const queryParams = getQueryParams();
				const cancelToken = c => {
					invoicesCancel = c;
				};
				const { data } = await PaymentService.getNonRKPayInvoicesV4(cancelToken, {
					...queryParams,
					invoiceNumber,
				});
				const [{ Id, IsEstimate }] = data.ItemList;
				push(`/payments/manualinvoice?id=${Id}${IsEstimate ? "&estimate=true" : ""}`);
			}
		} catch (err) {
			push(currentRoute);
			utils.notify({
				type: "error",
				message:
					activeType === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key
						? lang.t("Job could not be found")
						: lang.t("Estimate/Invoice number cannot be found"),
			});
		}
	};

	const onNewInvoice = () => {
		push(
			`/payments/manualinvoice${viewType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key ? "?estimate=true" : ""}`,
		);
	};

	// Because of the problem re-rendering this component we're enforced to perform the side effect of updating SelectedRecords
	// in this owefull way.
	const updateSelectedRecord = item => {
		setSelectedRecords(prevState => {
			const newSelectedRecords = prevState;

			if (newSelectedRecords[item.Id]) {
				delete newSelectedRecords[item.Id];
			} else {
				newSelectedRecords[item.Id] = { ...item };
			}

			setRecords(pState => {
				const newRecords = pState;

				for (const key in newRecords) {
					const record = newRecords[key];
					const disabled =
						Object.keys(newSelectedRecords).length == 0
							? false
							: !(record.ClientId === item.ClientId);

					newRecords[key] = { ...record, disabled };
				}

				return newRecords;
			});
			return newSelectedRecords;
		});

		forceUpdate();
	};

	const selectAllRecords = () => {
		if (Object.keys(selectedRecords).length !== Object.keys(records).length) {
			const obj = records.reduce((acc, record) => ({ ...acc, [record.Id]: record }), {});
			setSelectedRecords(obj);
		} else {
			setSelectedRecords({});
		}

		forceUpdate();
	};

	const getFilterParams = () => ({
		clientId: filters.clientId,
		organizationId: filters.organizationId,
		supervisorIds: filters.supervisorIds,
		startDate: filters.startDate,
		endDate: filters.endDate,
		invoiceNumber: filters.invoiceNumber,
		projectId: filters.projectId,
		locationId: filters.locationId,
		officerId: filters.officerId,
		startCreateDate: filters.startCreateDate,
		endCreateDate: filters.endCreateDate,
		onlyVoided: filters.onlyVoided ?? false,
		vehicleInvoicingRequired: filters.vehicleInvoicingRequired ?? false,
		pendingOfficerSubmission: filters.pendingOfficerSubmission ?? false,
		disputed: filters.disputed ?? null,
		paid: filters.paid,
		onlyOverpaid: filters.onlyOverpaid,
		archived: filters.archived ?? false,
		invoiceType: filters.invoiceType ?? null,
	});

	const getQueryParams = () => {
		const filterParams = getFilterParams();
		const queryParams = {
			pageNumber,
			displayCount: 25,
			asc: filters.asc,
			sortBy: filters.sortBy || NON_RKPAY_INVOICE_COLUMNS.DueDate,
			statusIds: null,
			isEstimate: false,
			pendingJobs: null,
			...filterParams,
		};

		switch (activeType) {
			case NON_RKPAY_INVOICE_TYPE.ESTIMATES.key:
				if (useNonrkpayEstimatesQueryEnabled) {
					// Remove properties not needed
					delete queryParams.pendingOfficerSubmission;
					delete queryParams.vehicleInvoicingRequired;
					delete queryParams.onlyOverpaid;
					delete queryParams.disputed;
					delete queryParams.isEstimate;
					delete queryParams.pendingJobs;
					delete queryParams.statusIds;
				} else {
					Object.assign(queryParams, {
						isEstimate: true,
						statusIds: [],
					});
				}
				break;
			case NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key:
				Object.assign(queryParams, {
					pendingJobs: true,
					statusIds: [],
				});
				break;
			case NON_RKPAY_INVOICE_TYPE.PAID.key:
				Object.assign(queryParams, {
					statusIds: [NON_RK_PAY_INVOICE_STATUS_V4.PAID],
				});
				break;
			case NON_RKPAY_INVOICE_TYPE.AWAITING_PAYMENT.key:
				Object.assign(queryParams, {
					statusIds: [
						NON_RK_PAY_INVOICE_STATUS_V4.PENDING_CLIENT_PAYMENT,
						NON_RK_PAY_INVOICE_STATUS_V4.PENDING_CLIENT_REVIEW,
					],
				});
				break;
			case NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key:
				Object.assign(queryParams, {
					statusIds: [
						NON_RK_PAY_INVOICE_STATUS_V4.CREATED,
						NON_RK_PAY_INVOICE_STATUS_V4.PENDING_AGENCY_REVIEW,
					],
				});
				break;
			default:
				break;
		}
		return queryParams;
	};

	const getEstimates = async () => {
		try {
			if (estimatesCancel) {
				estimatesCancel();
			}

			const queryParams = getQueryParams();
			const cancelToken = c => {
				estimatesCancel = c;
			};

			 // Convert string dates to Date objects because of Nexus Client
			 const dateFields = [
				"startDate",
				"endDate",
				"startCreateDate",
				"endCreateDate",
				"createDate",
				"startDueDate",
				"endDueDate",
				"startSentDate",
				"endSentDate"
			];
			dateFields.forEach((field) => {
				if (queryParams[field] && typeof queryParams[field] === "string") {
					queryParams[field] = utils.parseDateStringToDateNoTime(queryParams[field]);
				}
			});

			const { data } = await NonRKPayInvoiceEstimatesService.getPaginatedEstimates(queryParams, cancelToken);
			if (pageNumber === 1) {
				const newRecords = data.ItemList || [];
				setEstimateRecords(newRecords);
				setHasMoreEstimateRecords(data.Count > newRecords.length);
			} else {

				const newRecords = [...estimateRecords, ...(data.ItemList || [])];

				setEstimateRecords(newRecords);
				setHasMoreEstimateRecords(data.Count > newRecords.length);
			}
		} catch (error) {

			if (
			// plain fetch AbortError
				error?.name === "AbortError" ||
			// generator's wrapper: FetchError whose cause is AbortError
				(error?.name === "FetchError" && error?.cause?.name === "AbortError")
			) {
			return;
			}

			utils.notify({
				type: "error",
				message: lang.t("An error occurred fetching estimates")
			});
		}
	}

	const getInvoices = async () => {
		try {
			if (invoicesCancel) {
				invoicesCancel();
			}

			const queryParams = getQueryParams();
			const cancelToken = c => {
				invoicesCancel = c;
			};
			const { data } = await PaymentService.getNonRKPayInvoicesV4(cancelToken, queryParams);
			if (pageNumber === 1) {
				const newRecords = data.ItemList || [];
				setRecords(newRecords);
				setHasMoreRecords(data.Count > newRecords.length);
			} else {
				const [anyRecord = {}] = Object.values(selectedRecords);

				const newRecords = [...records, ...(data.ItemList || [])].map(record => {
					const disabled =
						Object.keys(selectedRecords).length === 0
							? false
							: !(
								record.ClientId === anyRecord.ClientId &&
								(record.ExcludeOfficerRate || false) ===
								(anyRecord.ExcludeOfficerRate || false)
							);

					return { ...record, disabled };
				});

				setRecords(newRecords);
				setHasMoreRecords(data.Count > newRecords.length);
			}
		} catch (error) {
			// TODO: Handle Error
		}
	};

	const getTotals = async () => {
		try {
			setLoadingCounts(true);

			const cancelToken = () => { };
			const queryParams = getFilterParams();

			/**
			 * This is a workaround to fix the issue with the counts
			 * endpoint not returning the disputed count when the filter
			 * is not set.
			 *
			 * TODO: Remove this once the issue is fixed in the backend.
			 */
			if (queryParams.disputed === null) {
				queryParams.disputed = false;
			}

			const { data } = await PaymentService.getNonRKPayInvoicesV4Counts(
				cancelToken,
				queryParams,
			);
			setCounts({
				EstimatesTotalAmount: utils.currencyFormatter(data.EstimatesTotalAmount),
				JobsPendingInvoiceCreationCount: data.JobsPendingInvoiceCreationCount,
				PendingSubmissionToClientTotalAmount: utils.currencyFormatter(
					data.PendingSubmissionToClientTotalAmount,
				),
				PendingClientPaymentTotalAmount: utils.currencyFormatter(
					data.PendingClientPaymentTotalAmount,
				),
				OverpaidInvoicesCount: data.OverpaidInvoicesCount,
				PendingSubmissionByOfficerCount: data.PendingSubmissionByOfficerCount,
			});
		} catch (error) {
			// TODO: Handle Error
		} finally {
			setLoadingCounts(false);
			setUpdateTotals(false);
		}
	};

	const updateFilters = (newFilters, requestCount) => {
		setUpdateTotals(requestCount);
		setFilters(newFilters);
	};

	const updateSort = (field, asc = null, type = activeType) => {
		let updateCounts = false;

		if (
			field === NON_RKPAY_INVOICE_COLUMNS.StartDateTime ||
			field === NON_RKPAY_INVOICE_COLUMNS.PaidDate
		) {
			return;
		}
		const updatedFilters = {
			...filters,
			sortBy: field,
			asc: asc != null ? asc : filters.sortBy === field ? !filters.asc : true,
		};

		// Clear vehicleInvoicingRequired filter when switching to Estimates
		if (type === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key) {
			delete updatedFilters.vehicleInvoicingRequired;
		} else {
			// Clear paid filter when switching to other types
			delete updatedFilters.paid;
		}

		if (type === NON_RKPAY_INVOICE_TYPE.PAID.key ||type === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key) {
			if (updatedFilters.onlyVoided) {
				updateCounts = true;
			}
			delete updatedFilters.onlyVoided;
		}

		if (excludeArchivedOptions.includes(type)) {
			if (updatedFilters.archived) {
				updateCounts = true;
			}
			delete updatedFilters.archived;
		}

		if (type === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key) {
			delete updatedFilters.startCreateDate;
			delete updatedFilters.endCreateDate;
			delete updatedFilters.officerId;
		}

		if (type !== NON_RKPAY_INVOICE_TYPE.PAID.key) {
			delete updatedFilters.onlyOverpaid;
		}

		if (type !== NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key) {
			delete updatedFilters.pendingOfficerSubmission;
			delete updatedFilters.disputed;
		}

		updateFilters(updatedFilters, updateCounts);
		setPageNumber(1);
		setRecords([]);
		setEstimateRecords([]);
		setHasMoreRecords(false);
		setHasMoreEstimateRecords(false);
		setSelectedRecords([]);

		const urlSearchParams = new URLSearchParams(updatedFilters);
		appendCoordinatorIdsParams(urlSearchParams, updatedFilters);

		const queryParams = urlSearchParams.toString();
		push(`/payments/v4/${type}?${queryParams}`);
	};

	const onTypeChange = type => {
		if (type !== activeType) {
			setActiveType(type);
			const [defaultSortField, defaultAsc] = getDefaultSortBy(type);
			// update sort will also reset page number, records and hasMoreRecords flag
			updateSort(defaultSortField, defaultAsc, type);
		}
	};

	const onFiltersChange = newFilters => {
		const updatedFilters = { ...newFilters, sortBy: filters.sortBy, asc: filters.asc };
		updateFilters(updatedFilters, true);
		setPageNumber(1);
		setRecords([]);
		setEstimateRecords([]);
		setSelectedRecords([]);
		setHasMoreRecords(false);
		setHasMoreEstimateRecords(false);

		const urlSearchParams = new URLSearchParams(updatedFilters);
		appendCoordinatorIdsParams(urlSearchParams, updatedFilters);

		const queryParams = urlSearchParams.toString();
		push(`/payments/v4/${activeType}?${queryParams}`);
	};

	const loadNextPage = () => {
		setPageNumber(prevState => prevState + 1);
	};

	const initFilters = () => {
		if (activeType) {
			if (!!query && Object.keys(query).length) {
				const updatedFilters = query || {};
				// update boolean filters that comes as string from query
				if (updatedFilters.vehicleInvoicingRequired) {
					updatedFilters.vehicleInvoicingRequired =
						updatedFilters.vehicleInvoicingRequired === "true";
				}
				if (updatedFilters.paid) {
					updatedFilters.paid = updatedFilters.paid === "true";
				}
				if (updatedFilters.onlyOverpaid) {
					updatedFilters.onlyOverpaid = !!(onlyVoidedToggleEnabled && updatedFilters.onlyOverpaid === "true");
				}
				if (updatedFilters.archived) {
					updatedFilters.archived = updatedFilters.archived === "true";
				}
				if (updatedFilters.onlyVoided) {
					updatedFilters.onlyVoided = updatedFilters.onlyVoided === "true";
				}
				updateFilters(updatedFilters, true);
			} else {
				const [defaultSortField, defaultAsc] = getDefaultSortBy(activeType);
				updateFilters({ sortBy: defaultSortField, asc: defaultAsc }, true);
			}
		}
	};

	useEffect(() => {
		if (initialFiltersLoaded) {
			if( useNonrkpayEstimatesQueryEnabled && activeType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key) {
				getEstimates();
			} else {
				getInvoices();
			}
		}
	}, [pageNumber, activeType, JSON.stringify(filters)]);

	useEffect(() => {
		if (initialFiltersLoaded && updateTotals) {
			getTotals();
		}
	}, [JSON.stringify(filters), updateTotals]);

	/**
	 * Remove disputed filter and query param
	 * if the feature flag is disabled.
	 * */
	useEffect(() => {
		const hasDisputedKey = Object.keys(filters).includes("disputed");
		if (!clientV4InvoicingDisputes && hasDisputedKey) {
			const newFilters = { ...filters };
			delete newFilters.disputed;
			onFiltersChange(newFilters, true);
		}
	}, [clientV4InvoicingDisputes, filters]);

	const onEditInvoice = invoiceId => event => {
		if (event) event.stopPropagation();
		push(
			`/payments/manualinvoice?id=${invoiceId}${activeType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key ? "&estimate=true" : ""}`,
		);
	};

	const onSendInvoices = invoiceIds => {
		push({
			pathname: "/payments/invoices-summary",
			query: { invoiceIds: invoiceIds.join(","), method: SEND_INVOICE_METHODS.INDIVIDUAL },
			state: { fromLocation: getCurrentLocation() },
		});
	};

	const onSendMultipleInvoices = () => {
		const invoiceIds = Object.values(selectedRecords).map(({ Id }) => Id);
		if (invoiceIds.length > 1) {
			setShowSelectSendInvoicesMethodModal(true);
		} else {
			onSendInvoices(invoiceIds);
		}
	};

	const onSendMultipleInvoicesConfirm = method => {
		setShowSelectSendInvoicesMethodModal(false);
		const invoiceIds = Object.values(selectedRecords).map(({ Id }) => Id);
		// We need this delay because Modal component hides the scrollbar when openning and when closing has a default animation
		// it takes time to set the scrollbar back
		setTimeout(() => {
			push({
				pathname: "/payments/invoices-summary",
				query: { invoiceIds: invoiceIds.join(","), method },
				state: { fromLocation: getCurrentLocation() },
			});
		}, 500);
	};

	const goToJob = jobId => event => {
		if (event) event.stopPropagation();
		push(`/jobs/${jobId}`);
	};

	const onApplyPayment = invoiceId => event => {
		if (event) event.stopPropagation();

		applyPaymentsModalRef.current.openModal(invoiceId);
	};


	const addToInvoice = (selectedJob = null) => {
		let currentSelectedJobs = selectedRecords;

		if (selectedJob) {
			updateSelectedRecord(selectedJob);

			currentSelectedJobs = {
				[selectedJob.Id]: { ...selectedJob },
			};
		}

		setSelectedRecords(currentSelectedJobs);
		forceUpdate();
		setShowAddToInvoice(true);
	};

	const showMultipleOfficerModal = (selectedId = null) => {
		setShowMultipleOfficers(true);
		setSelectedInvoiceId(selectedId);
	};

	const createInvoice = () => {
		const [job] = Object.values(selectedRecords);
		const { ClientId } = job;
		const jobs = Object.values(selectedRecords)
			.map(({ Id }) => Id)
			.join(",");

		push(`/payments/manualinvoice?clientId=${ClientId}&estimate=false&jobs=${jobs}`);
	};

	const isInvoicingV3 = user.Features.some(f => f.toLowerCase() === FEATURES.INVOICING_V3);
	const isInvoicingV2 =
		user.Organization.NonRKPayInvoicingEnabled || user.Organization.NonRKPayPaymentsEnabled;
	const isOfficerInvoicingV3 = user.Features.some(
		f => f.toLowerCase() === FEATURES.OFFICER_INVOICING_V3,
	);

	let paymentTabs =
		isInvoicingV3 || isInvoicingV2
			? PAYMENTS_TAB_MENU.map(item => {
				if (item.type === "manual") return { ...item, text: lang.t("Agency") };
				return { ...item, text: lang.t("Officer") };
			})
			: PAYMENTS_TAB_MENU;

	const isPaymentsTabV4Enabled = user.isSuperAdmin() || isInvoicingV3;

	if (isPaymentsTabV4Enabled) {
		paymentTabs = PAYMENTS_V4_TAB_MENU.map(item => {
			if (item.type === "v4")
				return {
					...item,
					text: isOfficerInvoicingV3 ? lang.t("Invoicing") : lang.t("Agency"),
				};
			return {
				...item,
				text: isOfficerInvoicingV3 ? lang.t("Legacy") : lang.t("Officer"),
			};
		});
	}

	const onClickTab = ({ tabNumber, url }) => {
		const thisTab = PAYMENTS_V4_TAB_MENU.find(tab => tab.type === "v4");
		if (tabNumber !== thisTab.tabNumber) push(url);
	};


	const onViewReceiptHandler = (ev, invoice) => {
		ev?.stopPropagation();
		push(`/payments/manualinvoice?id=${invoice.Id}`);
	};

	useEffect(() => {
		if (activeType) {
			setMultipleSelection(activeType === NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key);
		}
	}, [activeType]);

	useEffect(() => {
		if (!isPaymentsTabV4Enabled) {
			const { url } = paymentTabs.find(tab => tab.type === "manual");
			if (url) {
				push(url);
				return () => { };
			}
		}

		initFilters();
		setShowFilters(true);
		setInitialFiltersLoaded(true);

		return () => {
			if (invoicesCancel) {
				invoicesCancel();
			}
		};
	}, []);

	const cancelPendingJobs = () => {
		setSelectedRecords({});
		setRecords(pState => pState.map(record => ({ ...record, disabled: false })));
	};

	const cancelSendingInvoices = () => {
		setSelectedRecords({});
	};

	return (
		<main className="non-rk-pay-invoice-list__v4">
			<TabMenu
				tabs={paymentTabs}
				activeTab={
					paymentTabs.find(tab => tab.type === (isPaymentsTabV4Enabled ? "v4" : "manual"))
						.tabNumber
				}
				onClickTab={onClickTab}
				user={user}
			/>
			<div className="container margin-top-2rem">
				<div className="row">
					<div className="col-xs-12">
						<HeaderGrid
							gridOptions={NON_RKPAY_INVOICE_TYPE_OPTIONS}
							activeGrid={activeType}
							setActive={onTypeChange}
							showCounts={false}
							counts={counts}
							loadingCounts={loadingCounts}
						/>
					</div>
				</div>

				<div className="row form-group">
					<div className="col-md-3 col-sm-4 col-xs-12 col-xs-offset-0 search-container">
						<SearchField
							placeholder={lang.t("dynamic.Go to", {
								place:
									activeType === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key
										? "Job #"
										: "Estimate/Invoice #",
							})}
							onSearch={onInvoiceNumberFilter}
							iconClass="rkf rkf-arrow-right"
							clearable
						/>
					</div>
					<If condition={!user.isSuperAdmin()}>
						<div className="col-xs-5 col-md-offset-4 col-sm-offset-3 text-right padding-right-0 margin-top-8">
							<button
								type="button"
								id="non-rkpay-new-invoice"
								data-test-id="payments_page__create_invoice_btn"
								className="btn btn-primary width-min-200"
								onClick={onNewInvoice}
							>
								{viewType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key
									? lang.t("Create Estimate")
									: lang.t("Create Invoice")}
							</button>
						</div>
					</If>
				</div>

				<If condition={showFilters}>
					<NonRKPayInvoiceFilters
						user={user}
						activeFilters={filters}
						activeType={activeType}
						onFiltersChange={onFiltersChange}
						overpaidInvoicesCount={counts.OverpaidInvoicesCount}
						pendingSubmissionByOfficerCount={counts.PendingSubmissionByOfficerCount}
					/>
				</If>

				<If condition={activeType === NON_RKPAY_INVOICE_TYPE.ESTIMATES.key}>
					{ useNonrkpayEstimatesQueryEnabled && nonrkpayDetailPrepayEnhancements ? (
						<EstimatesTableV2
							updateSort={updateSort}
							filters={filters}
							records={estimateRecords}
							onEditInvoice={onEditInvoice}
							user={user}
							onApplyPayment={onApplyPayment}
							hasMoreRecords={hasMoreEstimateRecords}
							loadNextPage={loadNextPage}
						/>
					)
					:
					(
						<EstimatesTable
							updateSort={updateSort}
							selectAllRecords={selectAllRecords}
							multipleSelection={multipleSelection}
							filters={filters}
							records={records}
							onEditInvoice={onEditInvoice}
							selectedRecords={selectedRecords}
							updateSelectedRecord={updateSelectedRecord}
							user={user}
							onApplyPayment={onApplyPayment}
							hasMoreRecords={hasMoreRecords}
							loadNextPage={loadNextPage}
							estimateTabAvailablefundsColumn={estimateTabAvailablefundsColumn}
							nonrkpayDetailPrepayEnhancements={nonrkpayDetailPrepayEnhancements}
						/>
					)}
				</If>
				<If condition={activeType === NON_RKPAY_INVOICE_TYPE.PAID.key}>
					<PaidTable
						activeType={activeType}
						updateSort={updateSort}
						selectAllRecords={selectAllRecords}
						multipleSelection={multipleSelection}
						filters={filters}
						records={records}
						goToJob={goToJob}
						onEditInvoice={onEditInvoice}
						selectedRecords={selectedRecords}
						updateSelectedRecord={updateSelectedRecord}
						user={user}
						showMultipleOfficerModal={showMultipleOfficerModal}
						onViewReceiptHandler={onViewReceiptHandler}
						hasMoreRecords={hasMoreRecords}
						loadNextPage={loadNextPage}
					/>
				</If>
				<If condition={activeType === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key}>
					<PendingJobsTable
						updateSort={updateSort}
						selectAllRecords={selectAllRecords}
						multipleSelection={multipleSelection}
						filters={filters}
						records={records}
						goToJob={goToJob}
						selectedRecords={selectedRecords}
						updateSelectedRecord={updateSelectedRecord}
						user={user}
						addToInvoice={addToInvoice}
						hasMoreRecords={hasMoreRecords}
						loadNextPage={loadNextPage}
					/>
				</If>
				<If condition={activeType === NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key}>
					<PendingSubmissionTable
						updateSort={updateSort}
						selectAllRecords={selectAllRecords}
						multipleSelection={multipleSelection}
						filters={filters}
						records={records}
						onEditInvoice={onEditInvoice}
						selectedRecords={selectedRecords}
						updateSelectedRecord={updateSelectedRecord}
						user={user}
						showMultipleOfficerModal={showMultipleOfficerModal}
						hasMoreRecords={hasMoreRecords}
						loadNextPage={loadNextPage}
						goToJob={goToJob}
						onSendInvoices={onSendInvoices}
						canSendMultipleInvoices={bulkSendingInvoicesV4}
						clientV4InvoicingDisputesEnabled={clientV4InvoicingDisputes}
					/>
				</If>
				<If condition={activeType === NON_RKPAY_INVOICE_TYPE.AWAITING_PAYMENT.key}>
					<AwaitingPaymentTable
						updateSort={updateSort}
						selectAllRecords={selectAllRecords}
						multipleSelection={multipleSelection}
						filters={filters}
						records={records}
						onEditInvoice={onEditInvoice}
						selectedRecords={selectedRecords}
						updateSelectedRecord={updateSelectedRecord}
						user={user}
						showMultipleOfficerModal={showMultipleOfficerModal}
						hasMoreRecords={hasMoreRecords}
						loadNextPage={loadNextPage}
					/>
				</If>

				<div
					className={`bulk-actions ${Object.keys(selectedRecords).length > 0 ? "show-actions" : ""}`}
				>
					<div className="row">
						<div className="col-xs-11 col-sm-8 col-md-9 col-lg-10 text-right">
							{activeType === NON_RKPAY_INVOICE_TYPE.PENDING_JOBS.key && (
								<>
									<button
										type="button"
										className="btn btn-cancel"
										onClick={() => cancelPendingJobs()}
									>
										{lang.t("Cancel")}
									</button>
									<button
										type="button"
										className="btn btn-default"
										onClick={() => createInvoice()}
									>
										{lang.t("Create Invoice")}
									</button>
									<button
										type="button"
										className="btn btn-default"
										onClick={e => {
											e.stopPropagation();
											addToInvoice();
										}}
									>
										{lang.t("Add to Invoice")}
									</button>
								</>
							)}
							{activeType === NON_RKPAY_INVOICE_TYPE.PENDING_SUBMISSION.key && (
								<>
									<button
										type="button"
										className="btn btn-cancel"
										onClick={() => cancelSendingInvoices()}
									>
										{lang.t("Cancel")}
									</button>
									<button
										type="button"
										className="btn btn-default"
										onClick={e => {
											e.stopPropagation();
											onSendMultipleInvoices();
										}}
										data-test-id="payments_page__send-invoices-footer-btn"
									>
										{lang.t("Send Invoices")}
									</button>
								</>
							)}
						</div>
					</div>
				</div>
			</div>
			<ApplyPaymentsModal
				ref={applyPaymentsModalRef}
				user={user}
				invoiceVersion={3}
			/>
			<AddToInvoiceModal
				show={showAddToInvoice}
				onHide={() => {
					setShowAddToInvoice(false);
				}}
				router={push}
				jobs={selectedRecords}
				user={user}
				onCreateNewInvoice={createInvoice}
			/>
			<MultipleOfficerModal
				show={showMultipleOfficers}
				onHide={() => setShowMultipleOfficers(false)}
				router={push}
				user={user}
				invoiceId={selectedInvoiceId}
			/>
			<SelectSendInvoicesMethodModal
				show={showSelectSendInvoicesMethodModal}
				onHide={() => setShowSelectSendInvoicesMethodModal(false)}
				onSelected={onSendMultipleInvoicesConfirm}
				selectedRecords={selectedRecords}
			/>
		</main>
	);
};

NonRKPayInvoiceListV4.propTypes = {
	user: PropTypes.object,
	flags: PropTypes.object.isRequired,
	router: PropTypes.object.isRequired,
};

NonRKPayInvoiceListV4.defaultProps = {
	user: {},
};

export default withLDConsumer()(NonRKPayInvoiceListV4);
